import type { CSSProperties } from 'react';
import logoUrl from '../assets/pako-logo.png';

export function PakoLogo({
  size = 44,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`admin-pako-logo-frame ${className}`.trim()}
      style={{
        '--admin-logo-size': `${size}px`,
      } as CSSProperties}
    >
      <img
        src={logoUrl}
        alt="Pako AdminApp"
        className="admin-pako-logo"
        width={size}
        height={size}
        decoding="async"
        draggable={false}
      />
    </span>
  );
}
